__turbopack_context__.v({
  "clothesIcon": "fgQVQG_clothesIcon",
  "seeSimilarItemsText": "fgQVQG_seeSimilarItemsText",
  "wrapper": "fgQVQG_wrapper",
});
